module.exports = __webpack_public_path__ + "static/article-banner-0fec2d1441c3a91136fd094bb4d9bd11.jpg";